export const API_ENDPOINT = () => {
  if (process.env.GATSBY_PRODUCTION) {
    return 'https://eon-ea-backend-prod.azurewebsites.net/api';
  }

  return 'https://eon-ea-backend-dev.azurewebsites.net/api';
};

export const CURRENT_YEAR = new Date().getFullYear();

export const GERMANY_NAME = 'Deutschland';

/** Newest tab year, skipping forecast years (after CURRENT_YEAR). */
export const resolveInitialYear = (availableYears) => {
  if (!Array.isArray(availableYears) || availableYears.length === 0) {
    return null;
  }

  const withoutPrognose = availableYears.filter((year) => year <= CURRENT_YEAR);
  const years = withoutPrognose.length > 0 ? withoutPrognose : availableYears;
  return Math.max(...years);
};

export const UNIT_MW = 'MW';
export const UNIT_KW = 'kW';

export const debounce = (func, wait, leading = false) => {
  let timeout;
  return (...args) => {
    clearTimeout(timeout);
    if (leading && !timeout) {
      func.apply(this, args);
    }
    timeout = setTimeout(() => {
      timeout = null;
      if (!leading) {
        func.apply(this, args);
      }
    }, wait);
  };
}

export const createPathnameWithoutTrainlingSlash = (pathname) => {
  if (pathname.slice(-1) === '/' && pathname.length > 1) {
    return pathname.substring(0, pathname.length - 1);
  }

  return pathname;
}

const roundHalfUp = (value, fractionDigits) => {
  const rounded = Number(`${Math.round(`${value}e${fractionDigits}`)}e-${fractionDigits}`);
  return Number.isFinite(rounded) ? rounded : value;
};

export const formatNumberValue = (
  value,
  minimumFractionDigits = 2,
  maximumFractionDigits = 2
) => {
  if (value === undefined || value === null) {
    return '-';
  }

  return new Intl.NumberFormat('de-DE', {
    style: 'decimal',
    minimumFractionDigits,
    maximumFractionDigits,
    roundingMode: 'halfExpand'
  }).format(roundHalfUp(value, maximumFractionDigits));
}

export const isIframe = () => {
  if (typeof window !== 'undefined') {
    const urlParams = new URLSearchParams(window.location.search);
    const accessMethod = urlParams.get('access_method');

    return accessMethod === 'iframe';
  }

  return false;
};

export const getIframeOptions = () => {
  const defaultOptions = {
    header: true,
    stories: true,
    footer: true
  };

  if (typeof window === 'undefined') {
    return defaultOptions;
  }

  const urlParams = new URLSearchParams(window.location.search);
  const accessMethod = urlParams.get('access_method');

  if (accessMethod !== 'iframe') {
    return defaultOptions;
  }

  ['header', 'stories', 'footer'].forEach((key) => {
    const value = urlParams.get(key);

    if (value === 'false') {
      defaultOptions[key] = false;
    }
    if (value === 'true') {
      defaultOptions[key] = true;
    }
  });

  return defaultOptions;
};

export const isMinWidthDesktop = () => {
  if (typeof window !== 'undefined') {
    return window.innerWidth >= 1200;
  }

  return false;
};

export const sortData = (data, key, desc = true) => {
  data.sort((a, b) => {
    const aValue = a.values[key] || 0;
    const bValue = b.values[key] || 0;

    return aValue - bValue;
  });

  if (desc) {
    data.reverse();
  }

  return data;
};

export const adjustRanking = (data, valueIndex, rankIndex) => {
  // If we have entries that have the same value, we adjust the ranking so that both entries end up in the same place.

  const resultArray = [];
  data.forEach((item) => {
    if (!resultArray.length) return resultArray.push(item);
    const lastArrayItem = resultArray[resultArray.length - 1];

    if (item.rowData[valueIndex] === lastArrayItem.rowData[valueIndex]) {
      item.rowData[rankIndex] = lastArrayItem.rowData[rankIndex];
    }

    resultArray.push(item);
  });

  return resultArray;
};

export const getTableHead = (region, tableHeadData) => {
  if (!tableHeadData[region]) return tableHeadData[0];
  return tableHeadData[region];
};
